import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const RoundFilledIconWrapper = styled.div<{ $variant: 'default' | 'info' }>`
    display: flex;
    align-items: center;
    justify-items: center;
    line-height: 1;
    padding: ${getPurpurSpacing('150')};
    border-radius: ${getPurpurBorder('radiusFull')};
    color: ${({ $variant }) => getPurpurColor($variant === 'info' ? 'blue800' : 'functionalWhite')};
    background: ${({ $variant }) =>
        getPurpurColor($variant === 'info' ? 'backgroundStatusInfoMedium' : 'brandCorePurple')};
`;
